// extracted by mini-css-extract-plugin
export var wordContainer = "_p1-0";